import { gql } from 'graphql-request';

export interface CourseGraphQL {
  _id: string;
  url: string;
  title: string;
  subtitle: string;
  completed: boolean;
  completedPercentage: number;
  adminUrl: string;
  nextLesson?: {
    url: string;
  };
  topicsEntities: {
    _id: string;
    title: string;
    lessonsEntities: {
      _id: string;
      adminUrl: string;
      html: string;
      url: string;
      title: string;
      completed: boolean;
    }[];
  }[];
}

export const COURSE_CONTENT = gql`
  _id
  url
  title
  subtitle
  completed
  completedPercentage
  adminUrl
  nextLesson {
    url
  }
  topicsEntities {
    _id
    title
    lessonsEntities {
      _id
      adminUrl
      html
      url
      title
      html
      completed
    }
  }
`;

export const GET_COURSE = gql`
  query getCourseById($id: MongoID!){
    courseById(_id: $id) {
      ${COURSE_CONTENT}
    }
  }
`;

export const GET_DEMO_COURSE = gql`
  query getDemoCourse {
    course(filter: { isDemo: true }) {
      ${COURSE_CONTENT}
    }
  }
`;

export interface CourseListGraphQL {
  _id: string;
  url: string;
  title: string;
  subtitle: string;
  completed: boolean;
  completedPercentage: number;
  adminUrl: string;
  nextLesson?: {
    url: string;
  };
}

const courseListContent = gql`
  _id
  url
  title
  subtitle
  completed
  completedPercentage
  adminUrl
  nextLesson {
    url
  }
`;

export const GET_ALL_COURSES = gql`
  query getAllCourses {
    courses {
      ${courseListContent}
    }
  }
`;

export const GET_RECENT_COURSES = gql`
  query getRecentCourses($limit: Int) {
    currentUser {
      recentCourses(limit: $limit) {
        ${courseListContent}
      }
    }
  }
`;

export interface EnrolledClassroomGraphQL {
  name: string;
  curriculumEntity: {
    completed: boolean;
    completedPercentage: number;
    lessonsEntities: {
      title: string;
      html: string;
      url: string;
    }[];
    nextLesson: {
      title: string;
      html: string;
      url: string;
    };
  };
}

export const GET_ENROLLED_CLASSROOMS = gql`
  query getEnrolledClassrooms($limit: Int) {
    currentUser {
      enrolledClassrooms(limit: $limit) {
        name
        curriculumEntity {
          completed
          completedPercentage
          lessonsEntities {
            title
            html
            url
          }
          nextLesson {
            title
            html
            url
          }
        }
      }
    }
  }
`;

export function getNextLessonCta(course: {
  completed: boolean;
  completedPercentage: number;
}): string {
  if (course.completed) return 'Practice';
  if (course.completedPercentage ?? 0 > 0) return 'Resume';
  return 'Start';
}
